import store from '@state/store'

export default [
    {
        path: '/',
        name: 'home',
        component: () => lazyLoadView(import('@views/home')),
        meta: {
            authRequired: true,
        },
        props: (route) => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/login',
        name: 'login',
        component: () => lazyLoadView(import('@views/login')),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({name: 'home'})
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/register',
        name: 'register',
        component: () => lazyLoadView(import('@views/register')),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({name: 'home'})
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/confirm-account',
        name: 'confirm-account',
        component: () => lazyLoadView(import('@views/confirm')),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({name: 'home'})
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/forget-password',
        name: 'forget-password',
        component: () => lazyLoadView(import('@views/forgetPassword')),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({name: 'home'})
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                store.dispatch('auth/logOut')
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.meta.authRequired
                )
                // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? {name: 'home'} : {...routeFrom})
            },
        },
    },
    {
        path: '/404',
        name: '404',
        component: require('@views/_404').default,
        // Allows props to be passed to the 404 page through route
        // params, such as `resource` to define what wasn't found.
        props: true,
    },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    {
        path: '*',
        redirect: '404',
    },

    // estimate calculation
    {
        path: '/estimate/calculation/list/:ep_type/:district_id',
        name: 'estimateCalculationList',
        component: () => lazyLoadView(import('@views/payment/estimate_calculation/estimate_calculation_list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/estimate/calculation/create',
        name: 'estimateCalculationCreate',
        component: () => lazyLoadView(import('@views/payment/estimate_calculation/estimate_calculation_create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // estimate
    {
        path: '/estimate/list/:ep_type/:district_id',
        name: 'estimateList',
        component: () => lazyLoadView(import('@views/payment/estimate/estimate_list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/estimate/non-title/list/:ep_type/:district_id',
        name: 'estimateNonTitleList',
        component: () => lazyLoadView(import('@views/payment/estimate/estimate_list_non_title')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/estimate/create/',
        name: 'estimateCreate',
        component: () => lazyLoadView(import('@views/payment/estimate/estimate_create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/estimate/non-title/create/',
        name: 'estimateNonTitleCreate',
        component: () => lazyLoadView(import('@views/payment/estimate/estimate_create_non_title')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // EP and EC
    {
        path: '/voucher/ep_ec_voucher/list/:district_id',
        name: 'voucherEpEcVoucherList',
        component: () => lazyLoadView(import('@views/payment/ep_ec/ep_ec_voucher')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/print/voucher/ep_ec_voucher/list/:district_id',
        name: 'printEpEcVoucherList',
        component: () => lazyLoadView(import('@views/payment/ep_ec/print_ep_ec_voucher')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/debited/ep_ec_voucher/list/:district_id',
        name: 'debitedEpEcVoucherList',
        component: () => lazyLoadView(import('@views/view/voucher/debited_ep_ec_voucher')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/create/individually/voucher/:payment_voucher_id',
        name: 'createIndividuallyVoucher',
        component: () => lazyLoadView(import('@views/payment/voucher/create_individually_voucher')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/debited/group/ep/voucher/:power_group_id',
        name: 'debitedGroupEpVoucher',
        component: () => lazyLoadView(import('@views/payment/voucher/create_group_ep')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/individually/ec/voucher/:payment_voucher_id',
        name: 'individuallyEcVoucher',
        component: () => lazyLoadView(import('@views/payment/voucher/create_individually_ec')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/group/ec/voucher/:power_group_id',
        name: 'groupEcVoucher',
        component: () => lazyLoadView(import('@views/payment/voucher/create_group_ec')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/create/group/voucher/:power_group_id',
        name: 'createGroupVoucher',
        component: () => lazyLoadView(import('@views/payment/voucher/create_group_voucher')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/voucher/ep_ec_voucher/view/:district_id',
        name: 'voucherEpEcVoucherView',
        component: () => lazyLoadView(import('@views/payment/ep_ec/ep_ec_voucher_list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/voucher/ep_create/:ses_id',
        name: 'voucherEpCreate',
        component: () => lazyLoadView(import('@views/payment/ep_ec/create_ep')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/individually/ep/voucher/:ses_id/:payment_voucher_id',
        name: 'individuallyEpVoucher',
        component: () => lazyLoadView(import('@views/payment/voucher/create_individually_ep')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/voucher/ec_create/:ses_id',
        name: 'voucherEcCreate',
        component: () => lazyLoadView(import('@views/payment/ep_ec/create_ec')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/group/ep/voucher/create/:power_group_id',
        name: 'voucherGroupEpCreate',
        component: () => lazyLoadView(import('@views/payment/ep_ec/create_ep_group')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/voucher/group/ec_create/:power_group_id',
        name: 'voucherGroupEcCreate',
        component: () => lazyLoadView(import('@views/payment/ep_ec/create_ec_group')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // SES
    {
        path: '/ses/view/list',
        name: 'sesList',
        component: () => lazyLoadView(import('@views/ses/view/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/voucher-ep/list/:index/:ep_type',
        name: 'voucherEpList',
        component: () => lazyLoadView(import('@views/ses/view/voucher-ep-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/create',
        name: 'sesCreate',
        component: () => lazyLoadView(import('@views/ses/create/ses')),
        meta: {
            authRequired: true,
        },
        props: (route) => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/update',
        name: 'sesUpdate',
        component: () => lazyLoadView(import('@views/ses/view/update-list')),
        meta: {
            authRequired: true,
        },
        props: (route) => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/edit/:ses_id',
        name: 'sesEdit',
        component: () => lazyLoadView(import('@views/ses/create/ses-edit')),
        meta: {
            authRequired: true,
        },
        props: (route) => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/view/:ses_id',
        name: 'sesView',
        component: () => lazyLoadView(import('@views/ses/view/ses')),
        meta: {
            authRequired: true,
        },
        props: (route) => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/create/step-two/:ses_id',
        name: 'sesTwoCreate',
        component: () => lazyLoadView(import('@views/ses/create/ses-step-two')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Ses Document
    {
        path: '/ses/document/list',
        name: 'sesDocumentList',
        component: () => lazyLoadView(import('@views/ses/document/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/document/list/:ses_id',
        name: 'sesIndividualDocumentList',
        component: () => lazyLoadView(import('@views/ses/document/view')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/document/create/:ses_id',
        name: 'sesDocumentCreate',
        component: () => lazyLoadView(import('@views/ses/document/create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/document/update/:ses_document_id',
        name: 'sesDocumentUpdate',
        component: () => lazyLoadView(import('@views/ses/document/update')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Cheque print
    {
        path: '/ses/cheque/create',
        name: 'sesChequeCreate',
        component: () => lazyLoadView(import('@views/data/cheque_print/search')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // profile
    {
        path: '/user/profile',
        name: 'userProfile',
        component: () => lazyLoadView(import('@views/profile/index')),
        meta: {
            authRequired: true,
        },
        props: (route) => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/user/profile/update',
        name: 'userProfileUpdate',
        component: () => lazyLoadView(import('@views/profile/profile-update')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/user/password/update',
        name: 'userPasswordUpdate',
        component: () => lazyLoadView(import('@views/profile/password-update')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    //Batch
    {
        path: '/trainee/batch/list',
        name: 'traineeBatchList',
        component: () => lazyLoadView(import('@views/batch/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/batch/trainee/view/list',
        name: 'batchTraineeViewList',
        component: () => lazyLoadView(import('@views/view/batch/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Trainee
    {
        path: '/trainee/create/:ses_id',
        name: 'traineeCreate',
        component: () => lazyLoadView(import('@views/trainee/create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/list',
        name: 'traineeList',
        component: () => lazyLoadView(import('@views/trainee/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/view/:trainee_id',
        name: 'traineeView',
        component: () => lazyLoadView(import('@views/trainee/view')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/list/view',
        name: 'traineeListView',
        component: () => lazyLoadView(import('@views/view/trainee/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/edit/:trainee_id',
        name: 'traineeEdit',
        component: () => lazyLoadView(import('@views/trainee/edit')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // Estimate
    {
        path: '/report/estimate/create/:jvc_id',
        name: 'reportEstimateCreate',
        component: () => lazyLoadView(import('@views/data/estimate/create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/report/estimate/list',
        name: 'reportEstimateList',
        component: () => lazyLoadView(import('@views/data/estimate/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/report/estimate/edit/:estimate_report_id',
        name: 'reportEstimateEdit',
        component: () => lazyLoadView(import('@views/data/estimate/edit')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/report/estimate',
        name: 'reportEstimate',
        component: () => lazyLoadView(import('@views/data/estimate/report-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/report/jvrs',
        name: 'report-jvrs',
        component: () => lazyLoadView(import('@views/report/jvrs')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // Weekly
    {
        path: '/weekly/create',
        name: 'weeklyCreate',
        component: () => lazyLoadView(import('@views/data/weekly/create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/weekly/list',
        name: 'weeklyList',
        component: () => lazyLoadView(import('@views/data/weekly/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/weekly/edit/:weekly_id',
        name: 'weeklyEdit',
        component: () => lazyLoadView(import('@views/data/weekly/edit')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // Report
    {
        path: '/report/create',
        name: 'reportCreate',
        component: () => lazyLoadView(import('@views/data/report/create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/report/list',
        name: 'reportList',
        component: () => lazyLoadView(import('@views/data/report/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/report/edit/:report_id',
        name: 'reportEdit',
        component: () => lazyLoadView(import('@views/data/report/edit')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/report/all-report',
        name: 'reportAllReport',
        component: () => lazyLoadView(import('@views/report/report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Monthly
    {
        path: '/monthly/create',
        name: 'monthlyCreate',
        component: () => lazyLoadView(import('@views/data/monthly/create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/monthly/list',
        name: 'monthlyList',
        component: () => lazyLoadView(import('@views/data/monthly/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/monthly/edit/:monthly_id',
        name: 'monthlyEdit',
        component: () => lazyLoadView(import('@views/data/monthly/edit')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Import
    {
        path: '/plot-schedule/upload',
        name: 'plotScheduleUpload',
        component: () => lazyLoadView(import('@views/data/import/plot-schedule')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/mouza/upload',
        name: 'mouzaUpload',
        component: () => lazyLoadView(import('@views/data/import/mouza')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/union/upload',
        name: 'unionUpload',
        component: () => lazyLoadView(import('@views/data/import/union')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/upazilla/upload',
        name: 'upazillaUpload',
        component: () => lazyLoadView(import('@views/data/import/upazilla')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/village/upload',
        name: 'villageUpload',
        component: () => lazyLoadView(import('@views/data/import/village')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/district/upload',
        name: 'districtUpload',
        component: () => lazyLoadView(import('@views/data/import/district')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // Land/Mouza Rate
    {
        path: '/rate/land/list',
        name: 'rateLandList',
        component: () => lazyLoadView(import('@views/data/rate/land/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Structure Rate
    {
        path: '/rate/structure/list',
        name: 'rateStructureList',
        component: () => lazyLoadView(import('@views/data/rate/structure/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Tree Rate
    {
        path: '/rate/tree/list',
        name: 'rateTreeList',
        component: () => lazyLoadView(import('@views/data/rate/tree/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // EP ID Create
    {
        path: '/ses/ep-id/create',
        name: 'sesEpIdCreate',
        component: () => lazyLoadView(import('@views/data/ep_id/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ep/district/:district_id',
        name: 'epDistrict',
        component: () => lazyLoadView(import('@views/ses/view/district')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ep/search',
        name: 'epSearch',
        component: () => lazyLoadView(import('@views/payment/entitlement/entitlement_person/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // present address
    {
        path: '/ses/present-address/create',
        name: 'sesPresentAddressCreate',
        component: () => lazyLoadView(import('@views/data/present_address/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Bank Info
    {
        path: '/ses/bank/create',
        name: 'sesBankCreate',
        component: () => lazyLoadView(import('@views/data/ses_bank/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/bank/list',
        name: 'sesBankList',
        component: () => lazyLoadView(import('@views/data/ses_bank/view')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // power EP
    {
        path: '/ses/power/group/create',
        name: 'sesPowerGroupCreate',
        component: () => lazyLoadView(import('@views/data/power/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/power/group/list/:ses_id',
        name: 'sesPowerGroupList',
        component: () => lazyLoadView(import('@views/data/power/parent-group-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/power/child/group/list/:power_group_id',
        name: 'childGroupList',
        component: () => lazyLoadView(import('@views/data/power/child-group-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // User
    {
        path: '/user/info',
        name: 'userInfo',
        component: () => lazyLoadView(import('@views/profile/info')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/user/list',
        name: 'userList',
        component: () => lazyLoadView(import('@views/user-management/user/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/user/role/list',
        name: 'userRoleList',
        component: () => lazyLoadView(import('@views/user-management/role/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/user/role/assign/:user_id',
        name: 'assignRole',
        component: () => lazyLoadView(import('@views/user-management/role/assignRole')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/user/role/permission/create/:role_id',
        name: 'assignPermission',
        component: () =>
            lazyLoadView(import('@views/user-management/role/assignPermission')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // Report
    {
        path: '/report/monthly',
        name: 'reportMonthly',
        component: () => lazyLoadView(import('@views/report/monthly-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/report/weekly',
        name: 'reportWeekly',
        component: () => lazyLoadView(import('@views/report/weekly-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/report/ses',
        name: 'reportSes',
        component: () => lazyLoadView(import('@views/report/ses-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/report/ses/bank',
        name: 'reportSesBank',
        component: () => lazyLoadView(import('@views/report/ses-bank-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Entitlement district
    {
        path: '/payment/entitlement/district/:entitled_category_id',
        name: 'entitlementDistrict',
        component: () => lazyLoadView(import('@views/payment/entitlement/district')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/payment/entitlement/individual/:district_id/:entitled_category_id',
        name: 'entitlementIndividual',
        component: () => lazyLoadView(import('@views/payment/entitlement/individual')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/entitlement-person/search',
        name: 'entitlementPersonSearch',
        component: () => lazyLoadView(import('@views/payment/entitlement/entitlement_person/entitlement_person_search')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/entitlement-person/personal-information/:ses_id',
        name: 'EpPersonalInformation',
        component: () => lazyLoadView(import('@views/payment/entitlement/entitlement_person/personal_information')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/entitlement-person/household/:ses_id',
        name: 'EpHousehold',
        component: () => lazyLoadView(import('@views/payment/entitlement/entitlement_person/household')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/entitlement-person/land/:ses_id',
        name: 'EpLand',
        component: () => lazyLoadView(import('@views/payment/entitlement/entitlement_person/land')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/entitlement-person/structure/:ses_id',
        name: 'EpStructure',
        component: () => lazyLoadView(import('@views/payment/entitlement/entitlement_person/structure')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/entitlement-person/structure-rent/:ses_id',
        name: 'EpStructureRent',
        component: () => lazyLoadView(import('@views/payment/entitlement/entitlement_person/structure-rent')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/entitlement-person/business/:ses_id',
        name: 'EpBusiness',
        component: () => lazyLoadView(import('@views/payment/entitlement/entitlement_person/business')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/entitlement-person/business-employee/:ses_id',
        name: 'EpBusinessEmployee',
        component: () => lazyLoadView(import('@views/payment/entitlement/entitlement_person/business-employee')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/entitlement-person/tree/:ses_id',
        name: 'EpTree',
        component: () => lazyLoadView(import('@views/payment/entitlement/entitlement_person/tree')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/entitlement-person/voucher/:ses_id',
        name: 'EpVoucher',
        component: () => lazyLoadView(import('@views/payment/entitlement/entitlement_person/voucher')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/entitlement-person/profile/:ses_id',
        name: 'EpProfile',
        component: () => lazyLoadView(import('@views/payment/entitlement/entitlement_person/profile')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/entitlement-person/bank/:ses_id',
        name: 'EpBank',
        component: () => lazyLoadView(import('@views/payment/entitlement/entitlement_person/bank')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/entitlement-person/present-address/:ses_id',
        name: 'EpPresentAddress',
        component: () => lazyLoadView(import('@views/payment/entitlement/entitlement_person/present_address')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/entitlement-person/ep-ec-voucher/:ses_id',
        name: 'EpEpEcVoucher',
        component: () => lazyLoadView(import('@views/payment/entitlement/entitlement_person/ep_ec_voucher')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/entitlement-person/document/:ses_id',
        name: 'EpDocument',
        component: () => lazyLoadView(import('@views/payment/entitlement/entitlement_person/document')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/entitlement-person/file-tracking/:ses_id',
        name: 'EpFileTracking',
        component: () => lazyLoadView(import('@views/payment/entitlement/entitlement_person/file_tracking')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/entitlement-person/ses-worker/:ses_id',
        name: 'EpSesWorker',
        component: () => lazyLoadView(import('@views/payment/entitlement/entitlement_person/ses-worker')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // View Module
    {
        path: '/power/ep/view/:district_id',
        name: 'powerEpView',
        component: () => lazyLoadView(import('@views/view/power-ep/power-ep-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/power/child/ep/view/:power_group_id',
        name: 'powerChildEpView',
        component: () => lazyLoadView(import('@views/view/power-ep/child-group-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/vulnerable/view/list/:ep_type/:district_id',
        name: 'vulnerableViewList',
        component: () => lazyLoadView(import('@views/view/vulnerable/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/individual/voucher-info/list/:district_id',
        name: 'individualVoucherInfoList',
        component: () => lazyLoadView(import('@views/payment/voucher_info/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/rate/land/view',
        name: 'rateLandView',
        component: () => lazyLoadView(import('@views/view/rate/land-rate')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/rate/structure/view',
        name: 'rateStructureView',
        component: () => lazyLoadView(import('@views/view/rate/structure-rate')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/rate/tree/view',
        name: 'rateTreeView',
        component: () => lazyLoadView(import('@views/view/rate/tree-rate')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/land/info/view/:district_id',
        name: 'landInfoView',
        component: () => lazyLoadView(import('@views/view/land-info/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/land/plot/list',
        name: 'landPlotList',
        component: () => lazyLoadView(import('@views/view/land-info/land-plot')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/land/mouza/list',
        name: 'landMouzaList',
        component: () => lazyLoadView(import('@views/view/land-info/land-mouza')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // File tracking
    {
        path: '/ep/file-tracking/list',
        name: 'epFileTrackingList',
        component: () => lazyLoadView(import('@views/payment/entitlement/file_tracking/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ep/individual/file-tracking/create/:ses_id',
        name: 'epIndividualFileTrackingCreate',
        component: () => lazyLoadView(import('@views/payment/entitlement/file_tracking/create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // FAQ
    {
        path: '/faq',
        name: 'faq',
        component: () => lazyLoadView(import('@views/faq/faq')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Award Book
    {
        path: '/award-book/list',
        name: 'awardBookList',
        component: () => lazyLoadView(import('@views/data/award_book/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/award-book/view/list',
        name: 'awardBookViewList',
        component: () => lazyLoadView(import('@views/view/award_book/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // JVC
    {
        path: '/jvc/list',
        name: 'jvcList',
        component: () => lazyLoadView(import('@views/data/jvc/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    {
        path: '/jvc/view/list',
        name: 'jvcViewList',
        component: () => lazyLoadView(import('@views/view/jvc/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/jvc/view/jvc-land-ccl-ep-list/:mouza_id',
        name: 'jvcLandCclEpList',
        component: () => lazyLoadView(import('@views/view/jvc/jvc-land-ccl-ep-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/jvc/view/district/:district_id',
        name: 'jvcViewDistrict',
        component: () => lazyLoadView(import('@views/view/jvc/jvc_district')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/award-book/view/district/:district_id',
        name: 'awardBookViewDistrict',
        component: () => lazyLoadView(import('@views/view/award_book/award_book_district')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    {
        path: '/award-book/view/upazila/:upazila_id',
        name: 'awardBookViewUpazila',
        component: () => lazyLoadView(import('@views/view/award_book/award_book_upazila')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/report/jvc/list',
        name: 'reportJvc',
        component: () => lazyLoadView(import('@views/data/jvc/report/report-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/report/jvc/create',
        name: 'reportJvcCreate',
        component: () => lazyLoadView(import('@views/data/jvc/report/create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    {
        path: '/jvc/view/num-ep/:jvc_id',
        name: 'NoEpView',
        component: () => lazyLoadView(import('@views/data/jvc/num-ep')),
        meta: {
            authRequired: true,
        },
        props: (route) => ({user: store.state.auth.currentUser || {}}),
    },


    // Owners
    {
        path: '/owners/land/view/:district_id',
        name: 'ownerLandView',
        component: () => lazyLoadView(import('@views/view/owners/land/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/owners/structure/view/:district_id',
        name: 'ownerStructureView',
        component: () => lazyLoadView(import('@views/view/owners/structure/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/owners/tree/view/:district_id',
        name: 'ownerTreeView',
        component: () => lazyLoadView(import('@views/view/owners/tree/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/owners/crop-fish/view/:district_id',
        name: 'ownerCropFishView',
        component: () => lazyLoadView(import('@views/view/owners/crop-fish/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    {
        path: '/owners/business/view/:district_id',
        name: 'ownerBusinessView',
        component: () => lazyLoadView(import('@views/view/owners/business/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    {
        path: '/owners/residential/view/:district_id',
        name: 'ownerResidentialView',
        component: () => lazyLoadView(import('@views/view/owners/residential/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/owners/employee/view/:district_id',
        name: 'ownerEmployeesView',
        component: () => lazyLoadView(import('@views/view/owners/employee/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/owners/vulnerable/view/:district_id',
        name: 'ownerVulnerableView',
        component: () => lazyLoadView(import('@views/view/owners/vulnerable/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },




    // JVC_SES

    {
        path: '/jvc_ses/list',
        name: 'jvc_sesList',
        component: () => lazyLoadView(import('@views/data/jvc_ses/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/list',
        name: 'ses-list',
        component: () => lazyLoadView(import('@views/data/jvr_ses/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/jvr/list/:ses_id',
        name: 'ses-jvr-list',
        component: () => lazyLoadView(import('@views/data/jvr_ses/jvr-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/add/jvr/data/:ses_id',
        name: 'add_jvr_info',
        component: () => lazyLoadView(import('@views/data/jvr_ses/jvr_info.vue')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    /*{
        path: '/jvc_ses/view/list',
        name: 'jvc_sesViewList',
        component: () => lazyLoadView(import('@views/view/jvc_ses/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },*/

    //JVR
    {
        path: '/jvr/list',
        name: 'jvrList',
        component: () => lazyLoadView(import('@views/data/jvr/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/jvr/data/:jvr_id',
        name: 'jvrData',
        component: () => lazyLoadView(import('@views/data/jvr/jvr-data.vue')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/jvr/list/mouza',
        name: 'jvrMouzaList',
        component: () => lazyLoadView(import('@views/view/jvr/jvr_mouza')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/jvr/view/list',
        name: 'jvrViewList',
        component: () => lazyLoadView(import('@views/view/jvr/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/jvr/mouza/view/list',
        name: 'jvrMouzaViewList',
        component: () => lazyLoadView(import('@views/view/jvr/mouza')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/jvr/mouza/view/:mouza_id',
        name: 'jvrMouzaView',
        component: () => lazyLoadView(import('@views/view/jvr/single_mouza_detail')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/jvr/Plot/view/list',
        name: 'jvrPlotViewList',
        component: () => lazyLoadView(import('@views/view/jvr/plot')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/jvr/district/view/list',
        name: 'jvrDistrictViewList',
        component: () => lazyLoadView(import('@views/view/jvr/district')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // CCL
    {
        path: '/ccl/list',
        name: 'cclList',
        component: () => lazyLoadView(import('@views/data/ccl/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ccl/list/mouza',
        name: 'cclMouzaList',
        component: () => lazyLoadView(import('@views/view/ccl/ccl_mouza')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ccl/view/list',
        name: 'cclViewList',
        component: () => lazyLoadView(import('@views/view/ccl/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ccl/mouza/view/list',
        name: 'cclMouzaViewList',
        component: () => lazyLoadView(import('@views/view/ccl/mouza')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ccl/mouza/view/:mouza_id',
        name: 'cclMouzaView',
        component: () => lazyLoadView(import('@views/view/ccl/single_mouza_detail')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ccl/Plot/view/list',
        name: 'cclPlotViewList',
        component: () => lazyLoadView(import('@views/view/ccl/plot')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ccl/district/view/list',
        name: 'cclDistrictViewList',
        component: () => lazyLoadView(import('@views/view/ccl/district')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // Upazilla wise ccl/award/jvc/ses
    {
        path: '/ccl/upazila-wise-ccl-award-jvc-ses/:district_id',
        name: 'cclDistrictWiseUpazilaView',
        component: () => lazyLoadView(import('@views/view/ccl/upazila_wise_ccl_award_jvc_ses')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // mouza wise CclJvcAwardSes
    {
        path: '/ccl/mouza-wise-ccl-award-jvc-ses/:upazila_id',
        name: 'MouzaWiseCclAwardJvcSesView',
        component: () => lazyLoadView(import('@views/view/ccl/mouza_wise_ccl_award_jvc_ses')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ccl/district/view/:district_id',
        name: 'cclDistrictSingleView',
        component: () => lazyLoadView(import('@views/view/ccl/single_district_detail')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // dashboard ccl list
    {
        path: '/ccl/total/view/:district_id',
        name: 'totalCclView',
        component: () => lazyLoadView(import('@views/view/ccl/total_ccl_view')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ccl/view/collected/upazila/:upazila_id',
        name: 'totalCclCollectedUpazila',
        component: () => lazyLoadView(import('@views/view/ccl/collected_ccl_upazila')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ccl/view/collected/mouza/:mouza_id',
        name: 'totalCclCollectedMouza',
        component: () => lazyLoadView(import('@views/view/ccl/collected_ccl_mouza')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // end dashboard ccl list
    {
        path: '/ccl/update/:ccl_id',
        name: 'cclUpdate',
        component: () => lazyLoadView(import('@views/data/ccl/ccl_update_from_ses')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Age
    {
        path: '/age/view/list/:district_id',
        name: 'ageViewList',
        component: () => lazyLoadView(import('@views/view/age/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // EP Count
    {
        path: '/unpaid/ep/count',
        name: 'unpaidEpCount',
        component: () => lazyLoadView(import('@views/view/unpaid_ep/unpaid_ep_count')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Vulnerable view list
    {
        path: '/vulnerable/withoutType/list/:district_id',
        name: 'vulnerableWithOutTypeList',
        component: () => lazyLoadView(import('@views/view/vulnerable_without_type/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // payment in progress
    {
        path: '/payment/progress/list/:district_id/:ep_type',
        name: 'paymentInProgressList',
        component: () => lazyLoadView(import('@views/payment/payment_in_progress/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // individual Payment
    {
        path: '/payment/individual/list/:district_id/:ep_type',
        name: 'individualPaymentList',
        component: () => lazyLoadView(import('@views/payment/individual_payment/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Payment EP
    {
        path: '/payment/ep/list/:district_id',
        name: 'districtPaymentEP',
        component: () => lazyLoadView(import('@views/payment/payment_ep/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Entitlement district all
    {
        path: '/entitlement/district/all',
        name: 'entitlementDistrictAll',
        component: () => lazyLoadView(import('@views/payment/entitlement_district_all/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // view vouchers
    {
        path: '/payment/view/voucher/:district_id/:ep_type',
        name: 'paymentViewVoucher',
        component: () => lazyLoadView(import('@views/payment/view_voucher/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // print voucher
    {
        path: '/payment/voucher/print/:district_id/:ep_type',
        name: 'paymentVoucherPrint',
        component: () => lazyLoadView(import('@views/payment/print_voucher/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // payment mouza wise
    {
        path: '/payment/mouza/:district_id',
        name: 'paymentMouza',
        component: () => lazyLoadView(import('@views/payment/mouza_wise_payment/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // payment completed by power
    {
        path: '/payment/power/completed/:district_id/:ep_type',
        name: 'paymentCompletedByPower',
        component: () => lazyLoadView(import('@views/payment/payment_completed_by_power/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // payment completed
    {
        path: '/payment/completed/:district_id/:ep_type',
        name: 'paymentCompleted',
        component: () => lazyLoadView(import('@views/payment/payment_completed/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // tables create/edit
    {
        path: '/tables/create/land/:ses_id',
        name: 'tableLand',
        component: () => lazyLoadView(import('@views/ses/create/land')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    {
        path: '/tables/create/tree/:ses_id',
        name: 'tableTree',
        component: () => lazyLoadView(import('@views/ses/create/tree')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    {
        path: '/tables/create/structure/:ses_id',
        name: 'tableStructure',
        component: () => lazyLoadView(import('@views/ses/create/structure')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },


    {
        path: '/tables/create/crop/:ses_id',
        name: 'tableCrop',
        component: () => lazyLoadView(import('@views/ses/create/crop')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },





    // power payment breakdown
    {
        path: '/payment/power/breakdown',
        name: 'paymentPowerBreakdown',
        component: () => lazyLoadView(import('@views/payment/power_payments_breakdown/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // payment statement
    {
        path: '/payment/statement/list',
        name: 'paymentStatementList',
        component: () => lazyLoadView(import('@views/payment/payment_statement/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },


    // RRC
    {
        path: '/rrc/ses/list',
        name: 'rrcSesList',
        component: () => lazyLoadView(import('@views/data/rrc/ses-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/rrc/list/:ses_id',
        name: 'rrcList',
        component: () => lazyLoadView(import('@views/data/rrc/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // RRC
    {
        path: '/rrc/view/list',
        name: 'rrcViewList',
        component: () => lazyLoadView(import('@views/view/rrc/ses-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Data Cross Check
    {
        path: '/cross-check/ps-ab-ccl/list',
        name: 'crossCheckPsAbCclList',
        component: () => lazyLoadView(import('@views/data/ps_ab_ccls/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
    const AsyncHandler = () => ({
        component: AsyncView,
        // A component to use while the component is loading.
        loading: require('@views/_loading').default,
        // Delay before showing the loading component.
        // Default: 200 (milliseconds).
        delay: 200,
        // A fallback component in case the timeout is exceeded
        // when loading the component.
        error: require('@views/_timeout').default,
        // Time before giving up trying to load the component.
        // Default: Infinity (milliseconds).
        timeout: 10000,
    })

    return Promise.resolve({
        functional: true,
        render(h, {data, children}) {
            // Transparently pass any props or children
            // to the view component.
            return h(AsyncHandler, data, children)
        },
    })
}
